import ManageAdvancedLeadbotModal from './components/Modals/AddOns/ManageAdvancedLeadbot.modal';
import ManageLeadLimitAddonModal from './components/Modals/AddOns/ManageLeadLimitAddon.modal';
import ManageUsersModal from './components/Modals/AddOns/ManageUsers.modal';
import ManageWatermarkModal from './components/Modals/AddOns/ManageWatermark.modal';
import AddPaymentMethodModal from './components/Modals/AddPaymentMethod.component';
import CancelSubscriptionModal from './components/Modals/CancelSubscription/CancelSubscription.modal';
import PaymentCompletedModal from './components/Modals/PaymentCompleted';
import SubscriptionModalBoundary from './components/Modals/SubscriptionModalBoundary.component';
import TrialConfirmationModalComponent from 'src/providers/SubscriptionProvider/components/Modals/TrialConfirmationModal.component';
import { useModalsContext } from 'src/providers/ModalsProvider/Modals.context';
import { SubscriptionManagerContext } from './SubscriptionManager.context';
import useSubscriptionManager from './SubscriptionManager.hook';
import { tSubscriptionManagerProps } from './SubscriptionManager.types';

export default function SubscriptionManagerProvider(
  props: tSubscriptionManagerProps,
) {
  const { children } = props;
  const SubscriptionManager = useSubscriptionManager();
  const { showTrialConfirmModal } = useModalsContext();

  return (
    <SubscriptionManagerContext.Provider value={SubscriptionManager}>
      {SubscriptionManager.showManageUsersModal && (
        // RET-2032: contains a throw inside this modal to itself instead of
        // letting the root AlertCenterBoundary catch it and remount the
        // whole private tree (see SubscriptionModalBoundary's docblock).
        // `onClose` lets the fallback's close control flip
        // `showManageUsersModal` back to false so the customer can leave the
        // broken modal and retry, instead of being stuck looking at it.
        <SubscriptionModalBoundary
          modal="manage-users"
          onClose={() => SubscriptionManager.toggleManageUsersModal(false)}
        >
          <ManageUsersModal />
        </SubscriptionModalBoundary>
      )}
      {SubscriptionManager.showManageWatermarkModal && <ManageWatermarkModal />}
      {SubscriptionManager.showManageAdvancedLeadbotModal && (
        <ManageAdvancedLeadbotModal />
      )}
      {SubscriptionManager.showManageLeadLimitAddonModal && (
        <ManageLeadLimitAddonModal />
      )}
      {children}
      {/* RET-2428: before the add-card modal, so the form its links open
          paints on top of the trial confirmation. */}
      {showTrialConfirmModal && <TrialConfirmationModalComponent />}
      {SubscriptionManager.showAddPaymentMethodModal && (
        <AddPaymentMethodModal />
      )}
      {SubscriptionManager.showPaymentCompletedModal && (
        <PaymentCompletedModal />
      )}
      {SubscriptionManager.showCancelSubscriptionModal && (
        <CancelSubscriptionModal />
      )}
      {/*
       * RET-2428 — the trial confirmation lets the customer choose the card
       * that pays the plan, so it must read the saved cards this provider
       * fetches. ModalsProvider and SubscriptionProvider sit ABOVE this
       * provider (Providers.component.tsx), where useSubscriptionManagerContext
       * returns the empty default list, so the modal is mounted here. The flag
       * still lives in ModalsProvider; mounting on it resets the modal's
       * stage on every open, as before.
       */}
    </SubscriptionManagerContext.Provider>
  );
}
